"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelemetryLogger = void 0;
var types_1 = require("./types");
var TelemetryLogger = /** @class */ (function () {
    function TelemetryLogger(settings) {
        this.keyTransformer = settings.keyTransformer;
        this.transport = settings.transport;
    }
    TelemetryLogger.prototype.increment = function (key, value) {
        this.transport.send({
            key: this.keyTransformer(key),
            type: types_1.ETelemetryType.COUNTER,
            value: value,
        });
    };
    TelemetryLogger.prototype.timer = function (key, value) {
        this.transport.send({
            key: this.keyTransformer(key),
            type: types_1.ETelemetryType.TIMER,
            value: value,
        });
    };
    return TelemetryLogger;
}());
exports.TelemetryLogger = TelemetryLogger;
//# sourceMappingURL=telemetryLogger.js.map